import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import QueryTable from '../QueryTable';
import HashLink from '../HashLink';
import { PlusSquare, PencilSquare } from 'react-bootstrap-icons';

class CurrentStudents extends ChemComponent {
	constructor(props) {
		super(props);
		
		this.state = {
			searchCount: 0
		};
	}

	addStudent() {
		this.props.navigate('/GradOffice/Students/new');
	}
	
	editStudent(studentId) {
		this.props.setStudentEditable(true);
		this.props.navigate('/GradOffice/Students/' + studentId);		
	}

	viewStudent(studentId) {
		this.props.setStudentEditable(false);
		this.props.navigate('/GradOffice/Students/' + studentId);		
	}
	
	onSearchResult(data) {
		this.mergeState({
			searchCount: data.ResultCount
		});
	}

	render() {
		
		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'Current Students',
			columns: exportColumns,
			entity: 'ADMISSIONS.CURRENT_STUDENTS_VW',
		});
		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
				  <Container fluid>	
					<Row>
					  <Col xs={12}>
						<span style={{ fontSize: '18px', fontWeight: 'bold' }}>Current Students</span>
					  </Col>
					</Row>
					<Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
					  <Col xs={3} style={{ marginTop: 8}}>
						{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
							{exportData.map((excelFormField, index) => {
								return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
							{exportData.map((pdfFormField, index) => {
								return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={7}>
					  </Col>
					</Form.Group>
				  </Container>
				</Col>
			  </Row>
			  <Row>
				<Col>
				  <QueryTable parent={this} name='GradOffice_CurrentStudents' table={studentList} onResult={(data) => this.onSearchResult(data)} offsetHeight='140px' />
				</Col>
			  </Row>
			</Container>
		</>);		
	}
}

const studentList = {
	query: { entity: 'ADMISSIONS.CURRENT_STUDENTS_VW' },
	pageSize: 20,
	columns: [
		{ Header: props => <PlusSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.addStudent()} />, accessor: 'id', 
			Cell: props => <PencilSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.editStudent(props.row.values.STUDENT_ID)} />, width: 25 },
		{ Header: 'ID', accessor: 'STUDENT_ID', width: 60 },
		{ Header: 'Year Entered', accessor: 'YEAR_STARTED', width: 100 },
		{ Header: 'Name', accessor: 'STUDENT_NAME', width: 200, Cell: props => <HashLink onClick={() => props.parent.viewStudent(props.row.values.STUDENT_ID)}>{props.value}</HashLink> },
		{ Header: 'Student ID', accessor: 'STUDENT_CARD', width: 100 },
		{ Header: 'Email', accessor: 'EMAIL', width: 300 },
		{ Header: 'CA Resident', accessor: 'CA_RESIDENT', width: 120 },
		{ Header: 'Division', accessor: 'DIVISION', width: 80 },
		{ Header: 'PI', accessor: 'RES_DIRECTOR', width: 175 },
		{ Header: 'Assoc Advisor', accessor: 'ASSOC_ADVISOR', width: 175 },
		{ Header: 'Pay Plan', accessor: 'CURRENT_PAY_PLAN', width: 70 }
	]
};

const exportColumns = [
	{ Header: 'ID', accessor: 'STUDENT_ID', width: 12 },
	{ Header: 'Year Entered', accessor: 'YEAR_STARTED', width: 20 },
	{ Header: 'Name', accessor: 'STUDENT_NAME', width: 40 },
	{ Header: 'Student ID', accessor: 'STUDENT_CARD', width: 20 },
	{ Header: 'Email', accessor: 'EMAIL', width: 60 },
	{ Header: 'CA Resident', accessor: 'CA_RESIDENT', width: 24 },
	{ Header: 'Division', accessor: 'DIVISION', width: 16 },
	{ Header: 'PI', accessor: 'RES_DIRECTOR', width: 35 },
	{ Header: 'Assoc Advisor', accessor: 'ASSOC_ADVISOR', width: 35 },
	{ Header: 'Pay Plan', accessor: 'CURRENT_PAY_PLAN', width: 14 }
];

export default withRouter(CurrentStudents);
